import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";

import SwiperCore, { Navigation, Pagination } from 'swiper';


import { LocalizationModule, SharedModule } from 'src/core/index/shared.module.index';
import { AboutComponent } from "src/index";
import { AuthGuard } from "src/index/services.index";

SwiperCore.use([Navigation, Pagination]);

const routes: Routes = [ // Rotte definite ma RoutingModule non configurato, per poter gestire eventuale override da app esterna
    {
        path: 'about',
        canActivate: [AuthGuard],
        component: AboutComponent,
    }
];

@NgModule({
    declarations: [
        AboutComponent,
    ],
    imports: [
        CommonModule,
        LocalizationModule,
        SharedModule,
    ],
    providers: [
        AuthGuard,
    ],
    exports: [
        AboutComponent,
    ],
})
export class AboutModule {
    getRoutes() {
        return routes;
    }
}
